import React from "react";
import { createRoot } from "react-dom/client";
import "./utils/resizeObserver";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { registerServiceWorker } from "./utils/performance";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
    <ToastContainer
      position="top-center"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable={false}
      pauseOnHover
      theme="colored"
      limit={3}
    />
  </Provider>
);

// Register service worker for caching
registerServiceWorker();
